// larkite-dashboard.js - Dashboard functionality for PushToApp
// Loads and displays user credit balance, subscription, and activity

// Wait for Firebase to initialize
window.addEventListener('load', async function() {
  console.log('ðŸ“Š Dashboard initializing...');

  // Wait a moment for Firebase to initialize
  await new Promise(resolve => setTimeout(resolve, 1000));

  // Check if user is authenticated
  if (!window.LarkiteFirebase || !window.LarkiteFirebase.isUserAuthenticated()) {
    console.warn('âš ï¸ User not authenticated - showing login prompt');
    showLoginPrompt();
    return;
  }

  // Load dashboard data
  await loadDashboardData();

  // Listen for auth changes
  window.addEventListener('firebase-auth-changed', async (event) => {
    console.log('ðŸ”„ Auth state changed, reloading dashboard...');
    await loadDashboardData();
  });
});

// Load all dashboard data
async function loadDashboardData() {
  try {
    // Show loading state
    showLoading();

    // Get user data from Firestore
    const userData = await window.LarkiteFirebase.getUserData();

    if (!userData) {
      showError('Unable to load your account data. Please try refreshing the page.');
      return;
    }

    const email = (window.LarkiteFirebase.getCurrentUserEmail() || '').toLowerCase();
    const isAdmin = userData.isAdmin === true ||
      userData.admin === true ||
      email === 'adron.gordon@larkite.com' ||
      email === 'adron@larkite.com';
    const adminDownloadDashboard = document.getElementById('adminDownloadDashboard');
    if (isAdmin && adminDownloadDashboard) {
      adminDownloadDashboard.style.display = 'inline-flex';
    }

    // Update dashboard UI
    updateCreditBalance(userData.credits || 0);
    updateSubscriptionTier(isAdmin ? 'admin' : (userData.subscriptionTier || 'free'));
    updateSubscriptionStatus(userData);
    updateTotalBuilds(userData.totalCredits || 0);

    // Load recent activity
    const history = await window.LarkiteFirebase.getCreditHistory(5);
    updateRecentActivity(history);

    console.log('âœ… Dashboard data loaded successfully');
    hideError();
  } catch (error) {
    console.error('âŒ Error loading dashboard:', error);
    showError('Unable to load dashboard data. Please try refreshing the page.');
  }
}

// Update credit balance display
function updateCreditBalance(credits) {
  const element = document.getElementById('creditBalance');
  if (element) {
    element.innerHTML = `<span class="credit-number">${credits}</span>`;
  }
}

// Update subscription tier display
function updateSubscriptionTier(tier) {
  const element = document.getElementById('subscriptionTier');
  if (element) {
    const tierNames = {
      'free': 'Free Trial',
      'starter': 'Starter Plan',
      'pro': 'Pro Plan ($14.99/mo)',
      'enterprise': 'Enterprise',
      'developer': 'Developer Plan',
      'admin': 'Admin'
    };

    const tierClasses = {
      'free': 'tier-free',
      'pro': 'tier-pro',
      'enterprise': 'tier-enterprise',
      'developer': 'tier-developer',
      'admin': 'tier-admin'
    };

    const className = tierClasses[tier] || 'tier-free';
    element.innerHTML = `<span class="tier-name ${className}">${tierNames[tier] || tier}</span>`;
  }
}

// Update subscription status (expiry, renewal date, etc.)
function updateSubscriptionStatus(userData) {
  const element = document.getElementById('subscriptionStatus');
  if (!element) return;

  const status = userData.subscriptionStatus || 'active';
  const expiry = userData.subscriptionExpiry ? new Date(userData.subscriptionExpiry) : null;
  const creditsResetDate = userData.creditsResetDate ? new Date(userData.creditsResetDate) : null;
  const monthlyCredits = userData.monthlyCredits || 0;

  let statusHtml = '';

  if (userData.subscriptionTier === 'free') {
    statusHtml = '<span class="status-free">Free tier - 2 credits total</span>';
  } else if (status === 'active' && expiry) {
    const daysLeft = Math.ceil((expiry - new Date()) / (1000 * 60 * 60 * 24));
    statusHtml = `
      <span class="status-active">Active</span>
      <span class="expiry-info">Renews in ${daysLeft} days</span>
      <span class="credits-info">${monthlyCredits} credits/month</span>
    `;
  } else if (status === 'cancelled') {
    statusHtml = `
      <span class="status-cancelled">Cancelled</span>
      <span class="expiry-info">Access until ${expiry ? expiry.toLocaleDateString() : 'N/A'}</span>
    `;
  } else if (status === 'expired') {
    statusHtml = '<span class="status-expired">Expired - Please renew</span>';
  }

  element.innerHTML = statusHtml;
}

// Update total builds display
function updateTotalBuilds(total) {
  const element = document.getElementById('totalBuilds');
  if (element) {
    element.innerHTML = `<span class="builds-number">${total}</span>`;
  }
}

// Update recent activity list
function updateRecentActivity(history) {
  const element = document.getElementById('activityList');
  if (!element) return;

  if (history.length === 0) {
    element.innerHTML = '<p class="no-activity">No recent activity</p>';
    return;
  }

  const items = history.map(item => {
    const date = formatDate(item.timestamp);
    const action = formatAction(item.reason || item.type, item.amount || item.credits);

    return `
      <div class="activity-item">
        <span class="action">${action}</span>
        <span class="date">${date}</span>
      </div>
    `;
  }).join('');

  element.innerHTML = items;
}

// Format activity action
function formatAction(type, credits) {
  const actions = {
    'subscription_created': `âœ¨ Subscription activated (+${credits} credits)`,
    'subscription_renewed': `ðŸ”„ Subscription renewed (+${credits} credits)`,
    'credit_used': 'ðŸ“± App built (-1 credit)',
    'app_build': `ðŸ“± App built (${credits} credits)`,
    'first_time_grant': `ðŸŽ Welcome bonus (+${credits} credits)`,
    'credit_added': `âž• Credits added (+${credits})`,
    'credit_deducted': `âž– Credits used (-${Math.abs(credits)})`,
    'refund_build_failed': `ðŸ”„ Refund for failed build (+${credits})`,
    'order_paid': `âœ… Order completed (+${credits} credits)`,
    'monthly_reset': `ðŸ”„ Monthly credits reset (+${credits})`
  };
  return actions[type] || `${type} (${credits > 0 ? '+' : ''}${credits} credits)`;
}

// Format timestamp
function formatDate(timestamp) {
  if (!timestamp) return 'Unknown date';

  let date;
  if (timestamp.toDate) {
    // Firestore Timestamp
    date = timestamp.toDate();
  } else if (typeof timestamp === 'string') {
    date = new Date(timestamp);
  } else {
    date = new Date(timestamp);
  }

  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
  if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;

  return date.toLocaleDateString();
}

// Show loading state
function showLoading() {
  // Loading indicators are already in the HTML
}

// Show error message
function showError(message) {
  const errorElement = document.getElementById('errorMessage');
  if (errorElement) {
    errorElement.querySelector('p').textContent = message;
    errorElement.style.display = 'block';
  }
}

// Hide error message
function hideError() {
  const errorElement = document.getElementById('errorMessage');
  if (errorElement) {
    errorElement.style.display = 'none';
  }
}

// Show login prompt for unauthenticated users
function showLoginPrompt() {
  const dashboard = document.querySelector('.account-dashboard');
  if (dashboard) {
    dashboard.innerHTML = `
      <div class="login-prompt">
        <h2>Sign In Required</h2>
        <p>Please sign in to view your dashboard.</p>
        <p>You'll need to authenticate through the PushToApp desktop application first.</p>
        <a href="/account/login" class="button button-primary">Go to Login</a>
      </div>
    `;
  }
}

console.log('âœ… Dashboard script loaded');
